import moment from 'moment';
import React, { Component, Fragment } from 'react';
import { get } from '../../../server/actions';
import { groupBy, showFile, _addNotificationError } from '../../../server/util';
import { getLoginDistrictInfo } from '../../../server/utilDistrict';
import TmExportExcel from '../../Misc/tmExportExcel/tmExportExcel';
import tempEligibilityReportIcon from './../../../assets/img/mm/icon-9.png';
import download from 'downloadjs';
class LowBalReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: new Date(),
            endDate: new Date(),
            tempEligibilityData: [],
            userInfo: getLoginDistrictInfo(),
        }
    }
    componentWillMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }

    getSystemDateTime = (date) => {
        let _datetime = moment(date, 'YYYY-MM-DDTHH:mm:ss').utc().format("YYYY-MM-DDTHH:mm:ss")
        return _datetime;
    }
    bindData = () => {
        const districtID = this.state.userInfo.districtId;
        let schoolID = parseInt(this.props.selectSchool);
        const schoolYear = this.props.selectedSchoolYear || this.state.userInfo.schools[0].activeSchoolYear;
        let _url = '';
        const isDistId = schoolID > 0 ? false : true;
        if (isDistId) {
            _url = `/reports/districtLowBalanceReport/${districtID}?schoolYear=${schoolYear}&access_token=`;
        } else {
            _url = `/reports/districtLowBalanceReport/${districtID}?mealSchoolId=${schoolID}&schoolYear=${schoolYear}&access_token=`;
        }
        this.setState({ loading: true })
        get(_url).then((response) => {
            if (!response.ok) {
                if (response.status === 417 || response.status === 422) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                _addNotificationError(res.statusMessage, this.props)
                throw Error(res.errorMessage);
            } else if (res.statusCode === 422) {
                throw Error(res.statusMessage);
            } else {
                return res.blob();
            }
        }).then(blob => {
            let filename = "LowBalReport";
            showFile(blob, filename);
            this.setState({ loading: false })
        }).catch((error) => {
            let msg = ''
            if (typeof error === 'string') {
                msg = error;
            } else {
                msg = error.message;
            }
            _addNotificationError(msg, this.props);
            this.setState({ loading: false })
        }
        );
    }
    exportExcel = () => {
        let _self = this;
        this.setState({ loading: true });
        const districtID = this.state.userInfo.districtId;
        let schoolID = parseInt(this.props.selectSchool);
        const s_d_id = schoolID > 0 ? schoolID : districtID;
        const schoolYear = this.props.selectedSchoolYear || this.state.userInfo.schools[0].activeSchoolYear;
        const isDistId = schoolID > 0 ? false : true;
        let _url = '';
        if (isDistId) {
            _url = `/reports/districtLowBalanceReport/${districtID}?schoolYear=${schoolYear}&type=Excel&access_token=`;
        } else {
            _url = `/reports/districtLowBalanceReport/${districtID}?mealSchoolId=${schoolID}&schoolYear=${schoolYear}&type=Excel&access_token=`;
        }
        get(_url).then((response) => {
            if (!response.ok) {
                if (response.status === 400 || response.status === 417 || response.status === 422 || response.status == 500) {
                    return response.json();
                }
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                _addNotificationError(res.statusMessage, this.props)
                throw Error(res.errorMessage);
            } else if (res.statusCode === 422) {
                throw Error(res.statusMessage);
            } else if (res.statusCode === 400) {
                throw Error(res.statusMessage);
            } else if (res.statusCode === 500) {
                throw Error(res.statusMessage);
            } else {
                if (res.status == 200) {
                    return res.blob();
                } else {
                    throw Error(res.statusMessage);
                }

            }
        }).then(blob => {
            let filename = "LowBalReport";
            download(blob,
                filename + '.xls', "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");

            this.setState({ loading: false })
        }).catch((error) => {
            let msg = ''
            if (typeof error === 'string') {
                msg = error;
            } else {
                msg = error.message;
            }
            _addNotificationError(msg, _self.props);
            this.setState({ loading: false })
        }
        );
    }
    render() {
        return (
            <Fragment>
                <div className="reportCard reportCard-margin">
                    <div className="reportCard-body">
                        <div className="reportCard-widget">
                            <div className="reportCard-widget-title-wrapper">
                                <div className="reportCard-widget-date-primary">
                                    <img src={tempEligibilityReportIcon} />
                                </div>
                                <div className="reportCard-widget-meeting-info">
                                    <span className="reportCard-widget-pro-title color-3"><b>Low Balance Report</b></span>
                                </div>
                            </div>
                            <div className="reportCard-widget-meeting-points">
                            </div>
                            <div className='reportCard-widget-meeting-action'>
                                <div className="form-group">
                                    <button type='button' className='btn btn-sm btn-success' style={{ margin: '0px 5px 0px 0px' }} onClick={() => {
                                        this.bindData()
                                    }}>
                                        Download Report
                                    </button>
                                    <button type='button' className="btn btn-warning btn-sm" style={{ margin: '0px' }} onClick={() => {
                                        this.exportExcel()
                                    }}><i className="fa fa-file-excel-o"></i> Export</button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default LowBalReport;


// WEBPACK FOOTER //
// ./src/components/District/Reports/lowBalReport.js